import {isPlatformBrowser} from '@angular/common';
import {Component, EventEmitter, Inject, Input, Output, PLATFORM_ID} from '@angular/core';
import {Router} from '@angular/router';
import {StoreForexService} from 'src/app/navigation/service/store-forex.service';
import {FabricProfileItemList} from 'src/app/product-details/interface/fabric-profile-item-list';
import {MadeToOrderFabric} from 'src/app/product-details/interface/made-to-order-fabric';
import {Product} from 'src/app/product-details/interface/product';
import {FilterFabricProfileService} from 'src/app/product-details/service/filter-fabric-profile.service';

@Component({
	selector: 'fb-choose-fabric-more-option',
	templateUrl: './choose-fabric-more-option.component.html',
	styleUrls: ['./choose-fabric-more-option.component.scss']
})
export class ChooseFabricMoreOptionComponent {

	@Input() productData: Product = {} as Product;
	@Input() moreFabricList: FabricProfileItemList[] = [];
	@Input() madeToOrderFabric: MadeToOrderFabric = {} as MadeToOrderFabric;
	@Output() closeMoreFabric: EventEmitter<boolean> = new EventEmitter<boolean>();
	@Output() moreFabricImageUpdateInDisplayImage: EventEmitter<FabricProfileItemList> = new EventEmitter<FabricProfileItemList>();
	public copyMoreFabricList: FabricProfileItemList[] = [...this.moreFabricList];
	@Output() continueOption: EventEmitter<FabricProfileItemList> = new EventEmitter<FabricProfileItemList>();
	@Output() continueOptionForMTO : EventEmitter<MadeToOrderFabric> = new EventEmitter<MadeToOrderFabric>();
	public closeInfo:boolean = false;
	public closeMTOFabricInfo:boolean = false;

	public searchString:string = '';
	public deltaIndex:number = -1;
	public morePopupData: FabricProfileItemList = {} as FabricProfileItemList;
	public mTOPopupData: MadeToOrderFabric = {} as MadeToOrderFabric;
	public moreFabricDataForEmit: FabricProfileItemList = {} as FabricProfileItemList;
	public mTOFabricDataForEmit: MadeToOrderFabric = {} as MadeToOrderFabric;
	public isBrowser: boolean = false;

	constructor(
		private _router: Router,
		public storeForex: StoreForexService,
		private _filterFabricProfile: FilterFabricProfileService,
		@Inject(PLATFORM_ID) private _platformId: Object
		){
		this.isBrowser = isPlatformBrowser(this._platformId);
	}

	public closeOption(): void {
		this.closeMoreFabric.emit(false);

		if(this.mTOFabricDataForEmit.id) {
			this.continueOptionForMTO.emit(this.mTOFabricDataForEmit);
		}

		if(this.moreFabricDataForEmit.id){
			this.continueOption.emit(this.moreFabricDataForEmit);
		}
	}

	public openMoreMTOInfo(i: number, obj: MadeToOrderFabric, url: string): void {

		setTimeout((): void  => {
			this.closeMTOFabricInfo = true;
			this.mTOPopupData = obj;
		},0);
		if (this.isBrowser) {
			if(window.innerWidth<999){
				this.emitChooseMTOFabricData(i, obj);
			}
		}
	}



	public openMoreInfo(i: number, obj: FabricProfileItemList, url: string): void {

		setTimeout((): void => {
			this.closeMTOFabricInfo = false;
			this.closeInfo = true;
			this.morePopupData = obj;
		},0);
		if (this.isBrowser) {
			if(window.innerWidth<999){
				// this.moreFabricImageUpdateInDisplayImage.emit(obj);
				// this.moreFabricDataForEmit = obj;
				this.emitChooseFabricData(i, obj);
			}
		}
	}

	public emitChooseFabricData(i: number, obj: FabricProfileItemList): void {
		this.mTOFabricDataForEmit = {} as MadeToOrderFabric;
		this.closeInfo = true;
		this.deltaIndex = i;
		this.moreFabricImageUpdateInDisplayImage.emit(obj);
		this.moreFabricDataForEmit = obj;
	}

	public emitChooseMTOFabricData(i: number, obj: MadeToOrderFabric): void {

		this.closeMTOFabricInfo = true;
		this.deltaIndex = i;
		// this.moreFabricImageUpdateInDisplayImage.emit(obj);
		this.mTOFabricDataForEmit = obj;
	}

	public continueOptionInfo(): void {
		// this.closeMoreFabric.emit(false);

		if(this.mTOFabricDataForEmit.id) {
			this.continueOptionForMTO.emit(this.mTOFabricDataForEmit);
			return;
		}

		this.continueOption.emit(this.moreFabricDataForEmit)
	}

	public search(): void {
		// console.log(this.searchString);
		// debugger
		if (this.searchString == "") {
			this.moreFabricList = [...this.copyMoreFabricList]
			return
		}

		this.moreFabricList = [...this.copyMoreFabricList]
		let filteredData: FabricProfileItemList[] = [];
		this.moreFabricList.forEach((elm: FabricProfileItemList) => {
			if (elm.fabricPreview.name.toLocaleLowerCase().includes(this.searchString.toLocaleLowerCase())) {
				filteredData.push(elm);
			}
			else if (elm.fabricPreview.productOverview.toLocaleLowerCase().includes(this.searchString.toLocaleLowerCase())) {
				filteredData.push(elm);
			}
			else if (elm.fabricPreview.sku.toLocaleLowerCase().includes(this.searchString.toLocaleLowerCase())) {
				filteredData.push(elm);
			}
		});
		this.moreFabricList = [...filteredData];
	}

	public ngOnInit(): void {

		this.moreFabricDataForEmit = {} as FabricProfileItemList;
		this.copyMoreFabricList = [...this.moreFabricList];

		this.moreFabricList = this._filterFabricProfile.filterFabricBasedOnMTOProfileConsumption(
			this.moreFabricList,
			this.productData
		)
	}

	public openFabricDetails(): void {
		// debugger
		let url : string = '';

		if(this.mTOFabricDataForEmit.id) {

			url = this._router.serializeUrl(
				this._router.createUrlTree([`/product/fabric-product/${this.mTOFabricDataForEmit.slug}`])
			);
			window.open(url, '_blank');
			return
		}

		url = this._router.serializeUrl(
			this._router.createUrlTree([`/product/fabric-product/${this.moreFabricDataForEmit.fabricPreview.slug}`])
		);
		  if (this.isBrowser)
		  	window.open(url, '_blank');
	}
}
